import { Component, OnInit } from '@angular/core';
import { ABTest } from '@shared/abtest';

@Component({
  selector: 'webapp-compat-abtest',
  template: `
    <ng-container></ng-container>
  `,
})
export class CompatABTestComponent implements OnInit {
  constructor(private abtest: ABTest) {}

  ngOnInit() {
    const w = <any>window;
    w.webappCompatABTest = {
      getSessionExperimentVariation: this.abtest.getSessionExperimentVariation.bind(
        this.abtest,
      ),
      getUserExperimentVariation: this.abtest.getUserExperimentVariation.bind(
        this.abtest,
      ),
      getProjectExperimentVariation: this.abtest.getProjectExperimentVariation.bind(
        this.abtest,
      ),
    };
    if (w.webappCompatABTestReadyCallback) {
      w.webappCompatABTestReadyCallback();
    }
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat-abtest.component.ts